import React from "react";
import { hydrateRoot } from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import App from "./pages/App";

// Import fonts (fontsource)
import "@fontsource-variable/inter";
import "@fontsource/instrument-serif";
import "@fontsource-variable/space-grotesk";

hydrateRoot(
  document.getElementById("root")!,
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
